module.exports = __webpack_public_path__ + "img/6.d5c0747f.png";